import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'warranty-text-dialog',
    templateUrl: 'warranty-text-dialog.component.html',
    styleUrls: ['./warranty-text-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogActions, MatButton]
})
export class WarrantyTextDialogComponent {
  readonly dialogRef = inject<MatDialogRef<WarrantyTextDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  public isBusy: boolean = false;
  public warrantyText: string;

  constructor
  () {
    const data = this.data;

    this.isBusy = true;
    this.warrantyText = data.warrantyText as string;
    this.isBusy = false;
  }

  public close(): void {
    this.dialogRef.close(false);
  }
}
